import { A } from '@solidjs/router'
import { createEffect, createSignal } from 'solid-js'
import { userStore } from '/web/store'

const HeaderAccountMenu = (props: { username?: string }) => {
  const [menuOpened, setMenuOpened] = createSignal(false)
  const [menuHeight, setMenuHeight] = createSignal(0)

  let ref: HTMLDivElement | undefined

  createEffect(() => {
    if (ref) {
      if (menuOpened()) {
        setMenuHeight(ref.offsetHeight)
      } else {
        setMenuHeight(0)
      }
    }
  })

  return (
    <div class="user-menu relative grid w-[200px] cursor-pointer rounded-lg border border-white bg-gradient-to-r from-secondary to-primary px-4 text-sm font-medium transition-all duration-300">
      <div
        class={`absolute inset-0 h-full w-full rounded-lg bg-black transition-all  duration-300 ${
          menuOpened() ? 'opacity-100' : 'opacity-0'
        }`}
      ></div>
      <div
        onClick={() => setMenuOpened(!menuOpened())}
        class="wrap relative flex h-[30px] w-full items-center justify-between gap-2"
      >
        <div class="left flex items-center gap-1">
          <img width={24} height={24} src="/images/icons/menu-user.svg" alt="user" />

          <div class="user-name">{props.username}</div>
        </div>

        {/* right */}
        <div class="right flex items-center">
          <img
            class={`transition-all duration-300 ${menuOpened() ? 'rotate-180' : ''}`}
            width={15}
            height={15}
            src="/images/icons/arrow.svg"
            alt="arrow"
          />
        </div>
      </div>

      {/* options */}
      <div
        style={{
          'max-height': menuOpened() ? menuHeight() + 10 + 'px' : '0',
        }}
        class="overflow-hidden transition-all duration-300"
      >
        <div
          ref={ref}
          class="options relative mt-3 space-y-5 border-t border-cosplay-grey py-5 text-base"
        >
          <MenuItem name="My Account" href="/subscriptions/" img="/images/icons/account.svg" />
          <div class="wrap">
            <button
              onClick={() => userStore.buyTokensModal(true)}
              class="group relative flex items-center gap-4"
            >
              <div class="icon">
                <img width={24} height={24} src={'/images/icons/token.svg'} alt={'Tokens'} />
              </div>

              <p class="text transition-all duration-300 group-hover:text-cosplay-red">
                {`${userStore()?.profile?.totalAvailableTokens || 0} Tokens`}
              </p>
            </button>
          </div>
          <div class="wrap">
            <button
              onClick={() => {
                userStore.characterModal(true)
                userStore.closeSideMenu()
              }}
              class="group relative flex items-center gap-4"
            >
              <div class="icon">
                <img width={24} height={24} src={'/images/icons/character.svg'} alt={'Requests'} />
              </div>

              <p class="text transition-all duration-300 group-hover:text-cosplay-red">Requests</p>
            </button>
          </div>

          <MenuItem
            name="Generate Image"
            href="/generate-image/"
            img="/images/icons/generate.png"
          />
          <MenuItem name="Live Chat" href="/chat/" img="/images/icons/live-chat.png" />
          <MenuItem name="My Gallery" href="/gallery/" img="/images/icons/gallery.png" />
          <MenuItem
            name="Blog"
            href="http://www.cosplayfans.ai/blog/"
            img="/images/icons/blog.svg"
          />

          {/* drop-down */}
          <div class="drop-down border-b border-t border-cosplay-grey py-4">
            {/* links */}
            <ul class={`overflow-hidden opacity-100`}>
              <li class="mb-2 flex">
                <a href="/faq/" class="flex flex-row items-center gap-3">
                  <div class="icon">
                    <img width={20} height={20} src="/images/icons/question.svg" alt="icon" />
                  </div>
                  <span>FAQ</span>
                </a>
              </li>

              <li class="flex">
                <a href="/contact-us/" class="flex flex-row items-center gap-3">
                  <div class="icon">
                    <img width={20} height={20} src="/images/icons/envelope.svg" alt="icon" />
                  </div>
                  <span>Contact Us</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="wrap">
            <button
              onClick={() => {
                userStore.logout()
                window.location.reload()
              }}
              class="group relative flex items-center gap-4"
            >
              <div class="icon">
                <img width={24} height={24} src={'/images/icons/signout.svg'} alt={'Sign Out'} />
              </div>
              <p class="text group-hover:text-red transition-all duration-300">Sign Out</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const MenuItem = (props: { href: string; img: string; name: string }) => {
  return (
    <div class="wrap">
      <A href={props.href} class="group relative flex items-center gap-4">
        <div class="icon">
          <img width={24} height={24} src={props.img} alt={props.name} />
        </div>

        <p class="text transition-all duration-300 group-hover:text-cosplay-red">{props.name}</p>
      </A>
    </div>
  )
}

export default HeaderAccountMenu
